// Utilitarios compartilhados das telas de Adesao ao Plano (backoffice do AJ e
// da recuperanda mantem copias identicas deste arquivo).

export const STATUS_LABELS = {
  draft: "Rascunho",
  open: "Aberta",
  closed: "Encerrada",
  pending_approval: "Aguardando aprovação do AJ",
  approved: "Aprovado",
  rejected: "Rejeitado",
  published: "Publicado",
  superseded: "Substituído",
};

export const STATUS_COLORS = {
  draft: "grey",
  open: "success",
  closed: "blue-grey",
  pending_approval: "warning",
  approved: "teal",
  rejected: "error",
  published: "success",
  superseded: "grey lighten-1",
};

export const AUTHOR_LABELS = { admin: "Administrador Judicial", client_admin: "Recuperanda", user: "Credor", system: "Sistema" };

export function errorMessage(error, fallback = "Ocorreu um erro inesperado. Tente novamente.") {
  const content = error && error.response && error.response.data && error.response.data.content;
  if (content && content.error && content.error.message) return content.error.message;
  return fallback;
}

// O banco devolve datas em UTC como texto "YYYY-MM-DD HH:mm:ss".
export function parseUtc(value) {
  if (!value) return null;
  const text = String(value);
  const date = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(text) ? new Date(`${text.replace(" ", "T")}Z`) : new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateTime(value) {
  const date = parseUtc(value);
  return date ? date.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", dateStyle: "short", timeStyle: "short" }) : "—";
}

// <input type="datetime-local"> trabalha no horario de Brasilia; a API recebe UTC.
export function toLocalInput(value) {
  const date = parseUtc(value);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).format(date);
  return parts.replace(" ", "T");
}

export function fromLocalInput(value) {
  if (!value) return null;
  // Brasilia nao tem horario de verao desde 2019: UTC-3 fixo.
  const date = new Date(`${value}:00-03:00`);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function formatBytes(bytes) {
  const value = Number(bytes) || 0;
  if (value >= 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  if (value >= 1024) return `${Math.round(value / 1024)} KB`;
  return `${value} B`;
}

export function openBase64Pdf(base64) {
  const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
